<template>
  <div class="container-fluid">
    <Breadcrumb :values="{ Home: '/', Search: '/search', [studyGroup ? studyGroup.name : 'Study']: ''}"></Breadcrumb>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header">Files related to the study</div>
          <div class="card-body">
            <div v-if="studyGroup">
              <h4>{{studyGroup.name ? studyGroup.name : `Study group containing ${metadata.study_info.c_mi_number.value} study` }}</h4>
              <hr/>
              <Folder v-if="studyGroup.type === 'directory'" :structure="studyGroup" :title="studyGroup.name || 'Study group'" :depth="0" @refresh="studyGroupGet"></Folder>
              <FileList v-else :file="studyGroup" :depth="0"></FileList>
            </div>
            <p v-else> No files</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

import Breadcrumb from '../components/shared/Breadcrumb'
import FileList from '../components/FileStructure/FileList'
import Folder from '../components/FileStructure/Folder'
import generalActions from '../store/modules/general/actionTypes'
import studiesActions from '../store/modules/studies/actionTypes'

export default {
  name: 'FileStructure',
  components: { Breadcrumb, FileList, Folder },
  data () {
    return {
      studyGroup: null,
      alert: {
        type: '',
        icon: '',
        text: '',
        isVisible: false
      }
    }
  },
  methods: {
    ...mapActions({
      getRelatedFiles: studiesActions.FETCH_RELATED_STUDY_FILES,
      toggleLoading: generalActions.TOGGLE_LOADING
    }),
    toggle (value) {
      if (this.toggled.includes(value)) {
        const valueIndex = this.toggled.indexOf(value)
        this.$delete(this.toggled, valueIndex)
      } else {
        this.toggled.push(value)
      }
    },
    async studyGroupGet () {
      this.toggleLoading(true)
      this.studyGroup = await this.getRelatedFiles(this.id)
      this.toggleLoading(false)
    }
  },
  async mounted () {
    this.id = this.$route.params.id
    this.toggleLoading(true)
    await this.studyGroupGet()
    // this.studyGroup = await this.getRelatedFiles(this.id)
    this.toggleLoading(false)
  }
}
</script>

<style scoped>
a {
  cursor: pointer;
}
</style>
